<template>
  <v-card elevation="2" outlined>

    <v-card-text>

        <image-zoom
          class="mb-3"
          :regular="image.image_url"
          :zoom="image.image_url"
          :zoom-amount="4"
          :click-zoom="true"
          img-class="tag-image"
          >
        </image-zoom>
      <v-spacer></v-spacer>

        <v-chip  class="ma-1 v-size--small" props: x-small
            v-for="tag in visibleImageTags" :key="tag.id"
            close
            @click:close="removeTag(tag)"
        >
          {{ tag.name }}
          <v-chip
              props: x-small
              outlined
              style="border-width: 0;"
          >
            <v-spacer>{{ tag.category?.name }}</v-spacer>
          </v-chip>
        </v-chip>


        <v-spacer></v-spacer>
        <v-btn color="primary" depressed @click="showTaggerModal = true">Add Tag</v-btn>
        <TaggerModal v-if="showTaggerModal"
                     v-model="showTaggerModal" :photo_rec="image"
                     @close="showTaggerModal = false"
        />

    </v-card-text>
    <!--  -->
    <v-card-text v-if="$attrs.editable == true">
      <v-row>
        <v-col :cols="4" class="d-flex justify-content-start" >Prj ID: {{ image.project_id }}</v-col>
        <v-col :cols="4" class="d-flex justify-content-start">Job ID: {{ image.job_id }}</v-col>
        <v-col :cols="4" class="d-flex justify-content-start">Resp ID: {{ image.response_id }}</v-col>
      </v-row>
      <v-row>

        <v-col :cols="8" class="d-flex justify-content-start">Date: {{ image.date_acquired | formatDate }}</v-col>
        <v-col :cols="4" class="d-flex justify-content-start"></v-col>
      </v-row>

    </v-card-text>

    <slot></slot>
  </v-card>
</template>

<script>

import moment from 'moment'

import {mapActions, mapGetters} from 'vuex'
import TaggerModal from '../modals/TaggerModalV2'
import imageZoom from 'vue-image-zoomer';

export default {
  name: 'PhotoCardV2',
  components: {
    TaggerModal,
    imageZoom,
  },
  props: {
    image: Object,
  },
  filters: {
    formatDate: function (val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  computed: {
    // IT-704 (P4): chips are a removable input, so machine-owned (derived) tags
    // are hidden once derivation is enabled.
    ...mapGetters(['retainHumanTags']),
    visibleImageTags() {
      return this.retainHumanTags(this.image.tags)
    }
  },
  methods: {
    ...mapActions(['bulkUpdate', ]),

    removeTag(selected_tag) {

      let index = this.image.tags.indexOf(selected_tag)
        if (index >= 0) this.image.tags.splice(index, 1)
      // IT-704 (P4): send only human-picked tags when derivation is on.
      let activeTagIds = this.retainHumanTags(this.image.tags).map(tag => tag.id)
      let payload = {
        selected_photos: [this.image.id],
        selected_tags: activeTagIds,
        needs_review: this.image.needs_review,
        isQc: this.isQc
      }
      this.bulkUpdate(payload).then(() => {

      })
    },
    logReview() {
      let activeTagIds = this.retainHumanTags(this.image.tags).map(tag => tag.id)
      let payload = {
        selected_photos: [this.image.id],
        selected_tags: activeTagIds,
        needs_review: this.image.needs_review,
        isQc: this.isQc
      }

      this.bulkUpdate(payload).then(() => {
      })
    }
  },
  data() {
    return {
      showTaggerModal: false,
      photo: null,
      inQc: this.isQc
    }
  }
}
</script>

<style>
@media (min-width: 960px) {
  .tag-image{
  max-width:400px;
}
}
@media (min-width: 1264px) {
  .tag-image{
  max-width:530px;
}
}
@media (min-width: 1904px) {
  .tag-image{
  max-width:540px;
}
}

</style>
